import { UpdateMerchantBusinessPayload } from "@/models/payload/profile";
import profileService from "@/services/merchant";
import { useMutation } from "@tanstack/react-query";

function useUpdateMerchantBusiness() {
  const {
    mutate: updateMerchant,
    isLoading,
    isSuccess,
  } = useMutation({
    mutationFn: (command: UpdateMerchantBusinessPayload) => {
      return profileService.updateMerchantBusiness(command);
    },
  });
  return { updateMerchant, isLoading, isSuccess };
}

export default useUpdateMerchantBusiness;
